import React, { useCallback } from 'react';
import classnames from 'classnames';

import DisplayPayInfo from './DisplayPayInfo';
import SlashedPrice from './SlashedPrice';


function PackageOptions(props) {
  const {
    anchorToSubscribe,
    activeProgram,
    activeCampaign,
    hasPromoInURL,
    displayTimeUnit,
    isPromoPage,
    promoCodeInfo,
    handlePackageChange,
    mrSkinCampaign,
    oldPrices,
    programs,
    calculateRecurringAmmount,
    shouldAnimate,
  } = props;

  const isMembershipPage = window.location.pathname.includes('/account/purchase') && !anchorToSubscribe;

  const amountElement = useCallback((program) => {
    if (program?.details) {
      return (
        <span>
          {calculateRecurringAmmount(program)}
        </span>
      );
    }

    return (
      <span>
        {program?.currency.symbol}{program?.amount}
      </span>
    );
  }, [calculateRecurringAmmount]);

  return (
    programs.map((program, index) => (
      <label
        key={program.id}
        className={classnames(
          'package', {
            'animate-prices': shouldAnimate,
            'selected-package': (program.id === activeProgram.id),
            'white': (program.id === activeProgram.id) || isMembershipPage,
            'membership-option': isMembershipPage,
          })}
      >
        <div className="radio-btn-container">
          <input
            checked={program.id === activeProgram.id}
            className="package-radio"
            type="radio"
            value={program.id}
            onChange={handlePackageChange}
          />
          <span />
          {isMembershipPage && displayTimeUnit(program)}
        </div>
        <p
          className={classnames(
            'montserrat',
            'package-timespan', { 'package-timespan-nnlive': mrSkinCampaign })}
        >
          {isMembershipPage && amountElement(program)}
          {program.details ? (
            <span className="fw-600">
              {!isMembershipPage && displayTimeUnit(program)}
              <DisplayPayInfo
                activeCampaign={activeCampaign}
                hasPromoInURL={hasPromoInURL}
                isPromoPage={isPromoPage}
                program={program}
                promoCodeInfo={promoCodeInfo}
              />
            </span>
          ) : (
            <>
              Lifetime
              <small>Billed once. Never rebills.</small>
            </>
          )}
        </p>
        <p
          className={classnames(
            'montserrat',
            'package-amount-custom',
            'pull-right',
            { 'amount-mrskin': mrSkinCampaign })}
        >
          {!isMembershipPage && amountElement(program)}
          <SlashedPrice index={index} oldPrices={oldPrices} program={program} />
        </p>
      </label>
    ))
  );
}

export default PackageOptions;
